import AuthHeader from "components/AuthHeader";
import NonAuthLayoutWrapper from "components/NonAutnLayoutWrapper";
import { useRedux } from "hooks";
import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { parseRedirectTarget, resolveAndNavigateNotification } from "helpers/notificationRouting";

const DirectRedirection = () => {
    const { dispatch } = useRedux();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const target = parseRedirectTarget(location.search);
        if (target) {
            resolveAndNavigateNotification(target, { dispatch, navigate });
        } else {
            navigate('/');
        }
    }, [location]);

    return (
        <NonAuthLayoutWrapper>
            <Row className=" justify-content-center my-auto">
                <Col sm={8} lg={6} xl={5} className="col-xxl-4">
                    <div className="py-md-5 py-4">
                        <AuthHeader
                            title={"ยินดีต้อนรับสู่ " + process.env.REACT_APP_NAME}
                            subtitle="กำลังพาท่านไปสู้ส่วนที่ต้องการ"
                        />

                        <div className="mt-5 text-center text-muted">
                            <p>
                                <Link
                                    to="/auth-login"
                                    className="fw-medium text-decoration-underline"
                                >
                                    Login
                                </Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </NonAuthLayoutWrapper>
    );
}

export default DirectRedirection;